import { useCallback, useEffect, useState } from 'react';

/**
 * "Add to Home Screen" on Android Chrome and other browsers that fire
 * beforeinstallprompt. An installed web app gets its notifications delivered
 * more reliably and gives the learner an icon to come back by; on iPhone it is
 * the only way push works at all, but iOS never fires this event, so the
 * option simply does not appear there.
 */
export function useInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const onPrompt = (event) => {
      event.preventDefault();
      setDeferred(event);
    };
    const onInstalled = () => {
      setDeferred(null);
      setInstalled(true);
    };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferred) return false;
    deferred.prompt();
    const choice = await deferred.userChoice;
    setDeferred(null);
    return choice?.outcome === 'accepted';
  }, [deferred]);

  return { canInstall: Boolean(deferred) && !installed, promptInstall };
}
